// --- 页面 3: 新手指南 ---
function GuidePage({ onNavigate }) {
  return (
    <div className="p-8">
      <h1 className="text-3xl font-bold text-white">新手指南 页面</h1>
      <p className="text-gray-300 mt-2">这里将放置教程和帮助文档。</p>
    </div>
  );
}

export default GuidePage;
